import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const QueryBarElements = () => {
  const queryBarElements = usePluginEntities("views.elements.queryBar");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, queryBarElements.map((Component, idx) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ React.createElement(Component, { key: idx })
  )));
};
export default QueryBarElements;
